<template>
  <div class="my-table editQueuePage">
    <el-card class="tableCard p30 mt0">
      <div class="contactTitle flexCenter mb50">
        <span>{{$t('addQueue.txt1')}}</span>
        <div class="flexEnd">
          <div class="onCancelBtn mr30" @click="onBack">{{$t('addQueue.txt2')}}</div>
          <div class="searchBtn" @click="submitForm('editForm')">{{$t('addQueue.txt3')}}</div>
        </div>
      </div>
      <div class="editForm">
        <el-form ref="editForm" :model="queryInfo" :rules="addQueueRules">
          <el-row  :gutter="20">
            <el-col :span="8">
              <el-form-item :label="$t('addQueue.txt4')" prop="queueName">
                <el-input v-model="queryInfo.queueName" :placeholder="$t('addQueue.txt5')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('addQueue.txt6')" prop="projects">
                <el-select v-model="queryInfo.projects" multiple :placeholder="$t('addQueue.txt7')">
                  <el-option :label="item.label" :key="index" :value="item.value" v-for="(item,index) in projectOption"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('addQueue.txt8')" prop="userInfos">
                <el-select v-model="queryInfo.userInfos" multiple :placeholder="$t('addQueue.txt9')">
                  <el-option :label="item.label" :key="index" :value="item.value" v-for="(item,index) in userOption"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <!-- 面包屑 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('addQueue.txt10')}}</span>
        <span>{{$t('addQueue.txt11')}} / {{$t('addQueue.txt12')}} / {{$t('addQueue.txt13')}}</span>
      </div>
      <div class="flexEnd">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('addQueue.txt14')}}</el-checkbox>
      </div>
    </div>
      <!-- 宫格展示 -->
      <div>
        <div class="no-data" v-if="dataList.length == 0">{{$t('addQueue.txt15')}}</div>
        <div class="latticeShow">
          <ul class="cardContent">
            <el-checkbox-group v-model="checkedList" @change="handlecheckedListChange">
              <li ref="boxW" class="cardBox" v-for="(item,index) in dataList" :key="index">
                <div class="header">
                  <el-checkbox :key="item.id" :label="item.id">{{item.calculationName}}</el-checkbox>
                </div>
                <div class="contentBox">
                  <div class="flex">
                    <img class="desktopPic" src="@/assets/picture/icon/servicenode_img.png"/>
                    <div class="pt5">
                      <p>
                        <span class="labelTxt fl">{{$t('addQueue.txt16')}}</span>
                        <span class="txt fl">{{item.lanIp}}</span>
                      </p>
                      <p>
                        <span class="labelTxt fl">{{$t('addQueue.txt17')}}</span>
                        <span v-if="item.online" class="txt fl"><span class="dot"></span>{{$t('addQueue.txt18')}}</span>
                        <span v-else class="txt fl"><span class="dot greenDot"></span>{{$t('addQueue.txt19')}}</span>
                      </p>
                      <p>
                        <span class="labelTxt fl">{{$t('addQueue.txt20')}}</span>
                        <span class="txt fl">{{item.cpus}}</span>
<!--                         <span class="txt fl">
                          <el-input-number class="inputCpu" size="mini" v-model="item.cpus"></el-input-number>
                        </span> -->
                      </p>
                      <el-slider v-model="item.cpus"></el-slider>
                    </div>
                  </div>
                </div>
              </li>
            </el-checkbox-group>
          </ul>
        </div>
      </div>
  </div>
</template>

<script>
  import { formatDate } from "@/plugins/date.js";
  import qs from 'qs';
  export default {
    data() {
      return {
        visibleTitle:'',
        isIndeterminate: false,
        time:'',
        checkAll: false,
        checkedList: [],
        options:[],//测试数据
        addDotForm:{},//添加用户参数
        projectOption:[],//项目下拉
        userOption:[],//用户下拉
        //用于获取数据列表
        queryInfo: {
          queueName:'',
          projects:[],
          userInfos:[],
          calculations:[],
          state:1
        },

        dataList: [],
        addQueueRules:{
          queueName: [
          { required: true, message: this.$t('addQueue.txt21'), trigger: 'blur' },
          { pattern: /^[a-zA-Z]{1}\w*$/, message: this.$t('addQueue.txt22') },
          ],
          // projects: [
          //   { required: true, message: '请选择项目', trigger: 'change' }
          // ],
        }
      };
    },
    created() {
      this.loadData();
      this.getAllProjectList();
      this.getAllUserList();
    },
    filters: {
      formatDate(time) {
        var date = new Date(time);
        return formatDate(date, "yyyy-MM-dd");
      },
    },
    methods: {
      onBack(){
        this.$router.go(-1);
      },
      // 计算节点列表
      async loadData() {
        const {data: res} = await this.$http.post("/calculation/list");
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.dataList = res.result;
      },
      // 所有用户
      async getAllUserList() {
        const {data: res} = await this.$http.post("/user/info/list/all");
        if (!res.success) {
          return this.$message.error(res.message);
        }
        let list = res.result;
        list.map(e=>{
          let item = {
            label:e.userName,
            value:e.id,
            realName:e.realName
          }
          this.userOption.push(item);
        })
      },
      // 所有项目
      async getAllProjectList() {
        const {data: res} = await this.$http.post("/project/list/all");
        if (!res.success) {
          return this.$message.error(res.message);
        }
        let list = res.result;
        list.map(e=>{
          let item = {
            label:e.projectName,
            value:e.id
          }
          this.projectOption.push(item);
        })
      },
      handlecheckedListChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.checkedList.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkedList.length;
      },
      handleCheckAllChange(val) {
        this.checkedList = val ? this.dataList.map(item => item.id) : [];
        this.isIndeterminate = false;
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log(this.checkedList,'checkedList22');
            if(this.checkedList.length>0){
              this.addQueue();
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
            // 返回上一页
            returnPage() {
              this.$router.go(-1);
            },
      // 添加队列
      async addQueue(){
        let arr = [];
        this.dataList.map(e=>{
          this.checkedList.map(i=>{
            if(e.id == i){
              arr.push(e);
            }
          })
        });
        let data = {
          queueName:this.queryInfo.queueName,
          projects:[],
          userInfos:[],
          calculations:arr,
          state:1
        }
        let projects= this.queryInfo.projects;
        projects.map(e=>{
          let item = {
            id:e
          }
          data.projects.push(item);
        })
        this.userOption.map(e=>{
          this.queryInfo.userInfos.map(i=>{
           if(i === e.value){
            let item = {
              id:e.value,
              realName:e.realName
            }
            data.userInfos.push(item);
          }
        })
        });
        this.dataList.map(e=>{
          this.checkedList.map(i=>{
           if(i === e.value){
            let item = {
              id:e.value,
              calculationName:e.calculationName,
              cpus:e.cpus
            }
            data.calculations.push(item);
          }
        })
        });
        const {data: res} = await this.$http.post("/calculation/queue/add",data);
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.$message({
          type: 'success',
          message: res.message
        });
        this.$router.push({path: "/queueManangement"});
      },
    },
  };
</script>

<style lang="less" scoped>
  .editQueuePage{
    .mt0{
      margin-top: 0;
    }
    .editForm .el-input, .editForm .el-input__inner{
      height: auto !important;
    }
    .contactTitle{
      margin-bottom: 40px;
    }
    .contactTitle span{
      margin-right: 30px;
      cursor: pointer;
      font-size: 30px;
      font-weight: 500;
      color: #222222;
    }
    .no-data{
      text-align: center;
      color: #999;
      padding-top: 5rem;
    }
    .searchBox{
      padding: 30px 0;
    }
    .selectAll{
      padding:3.7rem 3rem 1.7rem 3rem;
      border-bottom: 1px solid #eee;
    }
    .el-checkbox__label{
      color: #1B3B7C;
    }
    .latticeShow{
      ul{
        li{
          margin-right: 4.2rem;
          margin-bottom: 4.2rem;
          float: left;
          padding:1.1rem 1.1rem 1.9rem 1.1rem;
          cursor: pointer;
          border-radius: 10px;
          .el-checkbox{
            display: block;
          }
/*          &:hover{
            background:#DAE4F9;
          }*/
        }
      }
    }
    .cardContent{
      width: 100%;
      margin-left: 0 !important;
      .cardBox:nth-of-type(3n+3){
        margin-right: 0;
      }
      .cardBox{
        padding:3rem !important; 
        background: #fff;
        border-radius: 3rem;
        margin-bottom: 3rem;
        margin-right: 3rem;
        width: 31.5%;
        width: 31.5%;
        /deep/ .el-checkbox{
          .el-checkbox__input{
            float: right;
          }
        }
        .header{
          border-bottom: 1px solid #EBEEF3;
          padding-bottom: 2rem;
          span{          
            font-size: 1.4rem;
            font-weight: 400;
            color: #222;
            cursor: pointer;
          }
          img{
            width: 1.4rem;
            height: 1.8rem;
            margin-right: 2rem;
            cursor: pointer;
          }
          img:last-of-type{
            margin-right: 0;
          }
        }
        .contentBox{
          padding-top:1.6rem;
          .desktopPic{
            width: 10.2rem;
            height: 10.2rem;
            margin-right: 3rem;
          }
          .inputCpu{
            width: 40px;
            height: 24px;
            display: block;
            /deep/ .el-input__inner{
              height: 24px;
            }
            /deep/ .el-input-number__decrease,/deep/ .el-input-number__increase{
              display: none;
            }
            /deep/ .el-input-number--mini .el-input__inner{
              padding:0;
            }
            /deep/ .el-input--mini .el-input__inner{
              width: 100%;
              padding:0;
            }
          }
          p:first-of-type{
            margin-bottom:1.5rem;
          };
          p:nth-of-type(2){
            margin-bottom:1.5rem;
          };
          p{            
            font-size: 1.2rem;
            font-weight: 400;
            color: #999999;
            overflow: hidden;
            span{
              color: #666;
            }
            .dot{
              width: 1.2rem;
              height: 1.2rem;
              background: #1AA600;
              border-radius: 50%; 
              margin-right: 1.2rem;
              display: block;
              float: left;
              margin-top: 5px;
            }
          }
          .w19{
            width: 19%;
          }
          .labelTxt{            
            font-size: 1.4rem;
            margin-right: 1.4rem;
            font-weight: 400;
            color: #999999;
          }
          .txt{            
            font-size: 1.4rem;
            font-weight: 400;
            color: #222222;
            line-height: 2rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
  }

</style>
